import { render, staticRenderFns } from "./RecetaEditar.vue?vue&type=template&id=a1d9ac54"
import script from "./RecetaEditar.vue?vue&type=script&lang=js"
export * from "./RecetaEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports